import { adminRoutes } from '@common/routes';

const PATHS_WITH_SEARCH = [adminRoutes.dumpLoadAllDumpLoads, adminRoutes.ordersInProgress, adminRoutes.ordersDone];
const EXACT_PATHS_WITH_SEARCH = new Set([adminRoutes.companies]);

export const shouldUseGlobalSearchForPath = (pathname: string): boolean =>
    PATHS_WITH_SEARCH.some(path => pathname.includes(path)) || EXACT_PATHS_WITH_SEARCH.has(pathname);
